import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { InteractService, AppMetadataHandler, CommonUtilty } from 'app';

@Component({
  selector: 'app-view-summary',
  templateUrl: './view-summary.component.html',
  styleUrls: ['./view-summary.component.scss']
})
export class ViewSummaryComponent implements OnInit {

  constructor(public appMetadataHandler : AppMetadataHandler,
              public commonUtility : CommonUtilty) { }

  
  @Input() summarySectionsList;  
  @Input() lookupList = [];
  @Input() header;  
  @Output() fieldChange = new EventEmitter()
  lookupsToBind = []
  lookup$
  ngOnInit(): void {
  this.lookupsToBind=this.lookupList
  this.lookup$ = this.commonUtility.initializeLookupList(this.lookupsToBind)
  console.log("lookups , ", this.lookup$);
    // this.summarySectionsList = this.summarySectionsList_dummy;
  }


  /*********Filter and sort***********/
  sort(sort: { key: string; value: string }): void {}
  filterMenuVisibilityChanged(event) {}
  getConfigKey(key) {}
  searchConfiguration(value) {}
  reset(): void {}
  updateValue(value: string, key) {
    // const input = value.target as HTMLInputElement;
      value = value === '-' ? null : value;
      // console.log("*****updated value = ", value);
      let data = {
        "key" : key,
        "value" : value
      }
      this.fieldChange.emit(data)
  }

  onFocus(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    if (input.value === '-') {
      input.value = ''; // Clear the '-' on focus
    }
  }
  /*filteredDataList = [];
  listOfData = [];
  dataListConfig = [];
  
  sortName: string | null = null;
  sortValue: string | null = null;
  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;

    if (this.sortName && this.sortValue) {
      let orderBy = this.sortValue === 'ascend' ? 'asc' : 'desc';
      this.filteredDataList = this.commonUtility.deepCopy(this.commonUtility.sortObject(this.sortName, this.filteredDataList, orderBy))
    } else {
      this.filteredDataList = this.listOfData;
    }
    console.log("sorted filteredDataList", JSON.stringify(this.filteredDataList));
  }

  searchValue: null;
  filterKey = null;

  filterMenuVisibilityChanged(event) {
    this.searchValue = null;
  }

  getConfigKey(key) {
    this.filterKey = key;
    console.log("config key", key);
  }

  searchConfiguration(value) {
    if (value) {
      this.filteredDataList = this.listOfData.filter(item => item[this.filterKey] ? item[this.filterKey].toLowerCase().includes(value.toLowerCase()) : [])
      this.searchValue = null;
    }
  }

  reset(): void {
    this.searchValue = null;
    this.filteredDataList = this.listOfData;
  }*/

    /*********Filter and sort***********/
  summarySectionsList_dummy = [
    {
      "titleWithIcon" : "Standard Plan Cd",
      "titleDesc" : "Lookup",
      "icon" : "home",
      "heading" : null,
      "sectionType" : "form",
      "sectionData" : [
        {
          "label" : "Name",
          "value" : "Standard Plan Cd",
          "pipe" : null,
          "pipeValue" : "",
          "showTag" : false,
          "tagColor" : null,
          "showBadge": false,
          "badgeStatus" : null,
          "additionalValue" : null
        }
      ],
    },
    {
      "titleWithIcon" : false,
      "titleDesc" : null,
      "icon" : "select",
      "heading" : "Advance Details",
      "sectionType" : "grid",
      "sectionData" : {
        "listHeader" : [
          {
            "header": "Publish",
            "key": "publish",
            "isVisible": true
          },
          {
            "header": "Do Not Display",
            "key": "dNd",
            "isVisible": true
          }
        ],
        "displayData" : [
          {
            "publish" : "Yes",
            "dNd" : "False",
            "pipe" : null,
            "pipeValue" : "",
            "key" : "ACCIDENT",
            "value" : "Accident",
            "criteria" : null,
            "sort" : "1"
          },
          {
            "publish" : "Yes",
            "dNd" : "Yes",
            "pipe" : null,
            "pipeValue" : "",
            "key" : "DEATH",
            "value" : "Death",
            "criteria" : null,
            "sort" : "2"
          }
        ]

      }
    },
    {
      "titleWithIcon" : null,
      "titleDesc" : null,
      "icon" : null,
      "heading" : "Summary",
      "sectionType" : "explanation-text",
      "sectionData" : {
        "desc" : "<div class=wordings>Lookup is created wih name <span class=pre>Standard Plan Cd,</span> and available for product line <span class=pre>Health.</span> Also, it is applicable for lookup data criteria <span class=pre>Agent Channel</span> who has parent lookup criteria as <span class=pre>Service.</span> The lookup consisting of <span class=pre>2 lookups</span>.</div>"
      }
    },
    {
      "titleWithIcon" : "Timeline",
      "titleDesc" : "",
      "icon" : "issues-close",
      "heading" : null,
      "sectionType" : "timeline",
      "sectionData" : [
        {
          "timelineColor" : "green",
          "title" : "Lookup creation",
          "statusColor" : "green",
          "status" : "Completed",
          "icon" : "Calender",
          "date" : "4 Apr 2019 11:10 AM",
          "calcDays" : "6 days ago",
          "addData" : [
            {
              "key" : "Work queue",
              "value": "Registration"
            },
            {
              "key" : "Assignee",
              "value": "rj@metamorphtech.com"
            },
            {
              "key" : "Priority",
              "value": "High"
            },
          ]
        },
        {
          "timelineColor" : "green",
          "title" : "Lookup creation",
          "statusColor" : "green",
          "status" : "Completed",
          "icon" : "Calender",
          "date" : "4 Apr 2019 11:10 AM",
          "calcDays" : "6 days ago",
          "addData" : [
            {
              "key" : "Work queue",
              "value": "Registration"
            },
            {
              "key" : "Assignee",
              "value": "rj@metamorphtech.com"
            },
            {
              "key" : "Priority",
              "value": "High"
            },
          ]
        }
      ]
    }
  ];

}
